import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "react-router-dom";

/** Small inline chip + contactless glyphs for the card, echoing a real card face */
const CardChip = () => (
  <svg width="34" height="25" viewBox="0 0 38 28" fill="none" aria-hidden="true">
    <rect
      x="0.5"
      y="0.5"
      width="37"
      height="27"
      rx="5.5"
      fill="white"
      fillOpacity="0.18"
      stroke="white"
      strokeOpacity="0.4"
    />
    <path
      d="M13 0.5V10.5C13 12.5 11.5 14 9.5 14H0.5M13 27.5V17.5C13 15.5 11.5 14 9.5 14M25 0.5V10.5C25 12.5 26.5 14 28.5 14H37.5M25 27.5V17.5C25 15.5 26.5 14 28.5 14"
      stroke="white"
      strokeOpacity="0.5"
    />
  </svg>
);

const ContactlessIcon = () => (
  <svg width="20" height="20" viewBox="0 0 22 22" fill="none" aria-hidden="true">
    <path
      d="M5.5 7.5a7.5 7.5 0 0 1 0 7M9 5.5a11 11 0 0 1 0 11M12.5 3.5a14.5 14.5 0 0 1 0 15"
      stroke="white"
      strokeOpacity="0.6"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-dark-background-main flex min-h-screen flex-col items-center justify-center px-4 py-12">
      <img src="/images/full-logo.svg" alt="mPay" className="mb-10 h-9 w-auto" />

      {/* Card styled to match the real mPay virtual cards (see components/card.tsx) */}
      <div
        className="font-dm-sans relative mb-10 h-[160px] w-70 overflow-hidden rounded-xl shadow-[0_24px_48px_-12px_rgba(0,0,0,0.25)]"
        style={{ background: "linear-gradient(180deg, #8CADCD 0%, #1B5D9F 100%)" }}
      >
        <div className="absolute inset-0 z-0">
          <img
            className="absolute bottom-0 left-0"
            src="/images/bl-card-blur.svg"
            alt=""
          />
          <img
            className="absolute top-0 right-0"
            src="/images/tr-card-blur.svg"
            alt=""
          />
          <img
            className="absolute top-0 right-0 z-20"
            src="/images/card-lines.svg"
            alt=""
          />
        </div>
        <div className="relative z-10 flex h-full flex-col justify-between p-4">
          <div className="flex items-start justify-between">
            <CardChip />
            <ContactlessIcon />
          </div>
          <div className="text-white">
            <div className="flex items-center justify-between pt-2">
              <div>
                <span className="text-xs font-medium text-white">
                  **** **** **** ????
                </span>
                <div className="text-[10px] font-medium text-white capitalize">
                  Page Not Found
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-md text-center">
        <p className="text-primary-500 mb-1 text-5xl font-bold tracking-wide sm:text-6xl">
          404
        </p>
        <h1 className="text-primary-500 mb-2 text-2xl font-semibold">
          We couldn't find that page
        </h1>
        <p className="text-primary-50 mb-8 text-sm leading-5">
          The link you followed doesn't point to anything here. It may have
          been moved, or it never existed in the first place.
        </p>

        <div className="flex w-full flex-col gap-3 sm:flex-row sm:justify-center">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="border-dark-stroke-3 text-primary-500 hover:bg-dark-grey-50 h-11 gap-2"
          >
            <ArrowLeft className="size-4" />
            Go Back
          </Button>
          <Button asChild className="gradient-button h-11 gap-2">
            <Link to="/dashboard">Go to Dashboard</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
